import styled from "styled-components";
import { NotosansjpMediumCloudBurst12px } from "../../styledMixins";

export const TableTag = styled.table`
  ${NotosansjpMediumCloudBurst12px}
  font-weight: 400;
  color: #192e55;
  border-collapse: collapse;
  margin: 10px 0 40px;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.15);
  white-space: nowrap;

  & tr {
    border-bottom: 1px solid #dddddd;
  }
  & td,
  & th {
    padding: 2px 4px;
    border: 1px solid black;
  }
  & td {
    text-align: right;
  }
  & td.negative {
    color: red;
  }
  & tr.spacer td,
  & tr.spacer th {
    border: 1px solid black;
    border-left: none;
    border-right: none;
  }
  & th.no-border,
  & td.no-border {
    border: none;
  }
`;
